export default {
    A1: {
        t: 's',
        v: '',
    },
    A2: {
        t: 's',
        v: '',
    },
    C2: {
        t: 's',
        v: '',
    },
    A3: {
        t: 's',
        v: '會計項目',
    },
    B3: {
        t: 's',
        v: '金額',
    },
    C3: {
        t: 's',
        v: '合計金額',
    },
    D3: {
        t: 's',
        v: '佔營收％',
    },
    '!ref': 'A1:D3',
    '!merges': [
        { s: { c: 0, r: 0 }, e: { c: 3, r: 0 } },
        { s: { c: 2, r: 1 }, e: { c: 3, r: 1 } },
        { s: { c: 0, r: 1 }, e: { c: 1, r: 1 } },
    ],
};
